import { api } from '@/utils/api';
import { Annotation } from './Annotation';

export default class AnnotationsRepository {
	async postAnnotations(data: Annotation) {
		try {
			const response = await api.post(`readings/annotations`, data);
			return response.data;
		} catch (error) {
			console.error(error);
		}
	}

	async getAnnotationsBySourceId(
		parameterId: any,
		sourceId: string,
		startDate: string,
		endDate: string,
	) {
		try {
			const response = await api.get(`readings/sources/${sourceId}/annotations`, {
				params: {
					startDate,
					endDate,
				},
			});

			const mapped = response.data.map((a: any) => {
				// ✅ CRÍTICO: No sobrescribir parameterId si ya viene del backend
				// Las notes pueden tener parameterId como array (múltiples parámetros)
				// Solo agregar parameterId si no existe en la respuesta del API
				
				return { 
					...a, 
					// Solo usar parameterId del parámetro si no viene del API
					parameterId: a.parameterId ?? parameterId 
				};
			});


			return mapped;
		} catch (error) {
			console.error('❌ [AnnotationsRepository] Error:', error);
			return []; // ✅ Retornar array vacío en caso de error
		}
	}
}
